<template>
  <div class="page-container">
    <div class="account-card">
      <span class="page-title">公司資訊</span>
      <div class="card-content">
        <div class="header">
          <div class="user-info">
            <h3>{{ company.name }}</h3>
            <p>{{ company.email }}</p>
          </div>
          <div class="buttons">
            <a-button @click="onDelete" ghost danger>刪除</a-button>
            <a-button @click="onSuspend" type="primary" ghost>停權</a-button>
            <a-button @click="onEdit" type="primary" ghost>編輯</a-button>
          </div>
        </div>
        <hr/>
        <div class="details">
          <div class="detail-row">
            <div>地址：<span>{{ company.address }}</span></div>
            <div>統一編號：<span>{{ company.tax_id }}</span></div>
            <div>註冊日期：<span>{{  }}</span></div>
          </div>
          <div class="detail-row">
            <div>狀態：<span>{{ company.is_active ? "正常" : "停權" }}</span></div>
            <div>公司代表人：<span>{{ company.representative }}</span></div>
            <div>公司管理人：<span>{{ owner?.last_name + owner?.first_name }}</span></div>
          </div>
        </div>
      </div>
      <div class="card-content account-list">
        <span class="title">帳號清單</span>
        <a-table :columns="columns"
                 :data-source="users"
                 rowKey="id"
                 :rowClassName="() => (`row`)">
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
import {message, Modal} from "ant-design-vue";

export default {
  name: 'AccountCard',
  inject: ['getUserData', 'clearUserData'],
  data() {
    return {
      company: {},
      owner: {},
      users: [],

      columns: [
        {
          title: '姓名',
          key: 'name',
          customRender: ({record}) => {
            return `${record?.last_name + record?.first_name || ""}`;
          },
        },
        {
          title: '電子信箱',
          key: 'email',
          customRender: ({record}) => {
            return `${record?.email || ""}`;
          },
        },
        {
          title: '權限',
          key: 'role',
          customRender: ({record}) => {
            return this.$t(`roles.${record.role}`)
          }
        },
        {
          title: '狀態',
          key: 'status',
          customRender: ({record}) => {
            return record.is_active ? '正常' : '停權'
          }
        },
      ],
    };
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {

      const token = localStorage.getItem('token');
      this.$axios.get(`/api/organizations/${this.$route.params.id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then(response => {
        console.log(response.data.data);
        this.company = response.data.data;
        this.owner = this.company.users.filter((item) => item.role === "admin")[0]
        this.users = this.company.users
      }).catch(error => {
        console.error(error);
      });
    },
    onDelete() {

      Modal.confirm({
        title: '刪除公司',
        content: '將會同步刪除此公司所有相關帳號以及設備，確認要刪除此公司帳號嗎？',
        okText: '刪除',
        okType: 'primary',
        okButtonProps: {
          danger: true
        },
        cancelText: '取消',
        onOk: () => {

          const token = localStorage.getItem('token');
          this.$axios.delete(`/api/organizations/${this.$route.params.id}`, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }).then(response => {
            console.log(response.data.data);
            this.$router.go(-1)
            message.success('已將公司刪除');
          }).catch(error => {
            console.error(error.status);
            if (error.status === 401) {
              this.$router.push('/login');
            }
          });
        },
      });
    },
    onSuspend() {

      const token = localStorage.getItem('token');
      const isActive = this.company.is_active
      this.$axios.patch(`/api/organizations/${this.$route.params.id}`, {
        is_active: !isActive
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then(response => {
        console.log(response.data.data);
        this.fetchData();
        message.success(`已將公司${isActive ? "停權" : "復權"}`);
      }).catch(error => {
        console.error(error.status);
        if (error.status === 401) {
          this.$router.push('/login');
        }
      });
    },
    onEdit() {
      this.$router.push(`/company/edit/${this.$route.params.id}`);
    },
    formatDate(date) {
      try {
        return new Intl.DateTimeFormat("en-CA", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }).format(date);
      } catch (e) {
        return ""
      }
    },
  }
};
</script>

<style scoped>
.title {
  font-size: 20px;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 10px;
}

.ant-table-wrapper {
  margin-top: 28px;
}

.card-content {
  background-color: white;
  border-radius: 8px;
  margin-top: 16px;
}

.header {
  display: flex;
  justify-content: space-between;
  padding: 28px 32px;
}

hr {
  border: 1px solid #e0e0e0;
}

.user-info h3 {
  font-size: 24px;
  margin: 0;
}

.user-info p {
  color: gray;
  margin: 0;
}

.buttons button {
  margin-left: 10px;
}

.details {
  display: grid;
  grid-template-columns: repeat(3, auto);
  gap: 8px 16px;
  padding: 28px 32px;
}

.account-list {
  padding: 28px 32px;
  margin-top: 28px;
}

.detail-row {
  display: contents;
}

.detail-row div {
  text-align: left;
  color: #999999;
  size: 18px;
}

.detail-row div span {
  color: #333333;
}
</style>
